import styled from 'styled-components';
import { colors } from '../../../stylesheets';

const ModalHeader = styled.div`
  width: 100%;
  height: 60px;
  background-color: ${colors.secondary};
`;

export default ModalHeader;
